// react-flatpickr components
import Flatpickr from "react-flatpickr";

// react-flatpickr styles
import "flatpickr/dist/flatpickr.css";

// Material Dashboard 2 PRO React TS components
import MDInput from "components/MDInput";
import InputAdornment from "@mui/material/InputAdornment";
import Icon from "@mui/material/Icon";

// types
interface Props {
  input?: {
    [key: string]: any;
  };
  showIcon?: boolean;
  iconPosition?: "start" | "end";
  [key: string]: any;
}

function MDDatePicker({
  input,
  showIcon = true,
  iconPosition = "start",
  ...rest
}: Props): JSX.Element {
  return (
    <Flatpickr
      {...rest}
      render={({ defaultValue }: any, ref: any) => (
        <MDInput
          size={"small"}
          sx={{ width: "150px" }}
          {...input}
          defaultValue={defaultValue}
          inputRef={ref}
          InputProps={{
            ...(showIcon && iconPosition === "start"
              ? {
                  startAdornment: (
                    <InputAdornment position="start">
                      <Icon>calendar_today</Icon>
                    </InputAdornment>
                  ),
                }
              : {}),
            ...(showIcon && iconPosition === "end"
              ? {
                  endAdornment: (
                    <InputAdornment position="end">
                      <Icon>calendar_today</Icon>
                    </InputAdornment>
                  ),
                }
              : {}),
          }}
        />
      )}
    />
  );
}

MDDatePicker.defaultProps = {
  input: {},
  showIcon: true,
  iconPosition: "start",
};

export default MDDatePicker;
